/**
 * Build a staff-friendly list of packages / add-ons from a booking row + eventAddons.
 */
export function summarizeBookingPackages(row) {
  const sections = [];
  const addons = row?.eventAddons;
  if (addons && typeof addons === "object") {
    for (const category of Object.keys(addons)) {
      const items = addons[category];
      if (!Array.isArray(items) || items.length === 0) continue;
      const names = items
        .map((i) => i?.itemName || i?.name || i?.title)
        .filter(Boolean);
      if (names.length) sections.push({ category, items: names });
    }
  }

  const legacyPairs = [
    ["Decoration", row?.selectedDecoration],
    ["Cake", row?.selectedCake],
    ["Flowers", row?.selectedFlowers],
    ["Party props", row?.selectedPartyProps],
    ["Gifts", row?.selectedGiftsDetails],
    ["Photo / shoot", row?.selectedPhotoDetails],
  ];
  for (const [label, val] of legacyPairs) {
    const s = val != null ? String(val).trim() : "";
    if (s) sections.push({ category: label, items: [s] });
  }

  return sections;
}
